export default __webpack_public_path__ + "static/media/404.7ac28a69.png";